<template>
  <el-dialog :title='dialogTitle' :visible.sync='detailDialogVisible' width='800px' center top='10vh'>
    <div class='detail'>
      <div class='baseInfo'>
          <div class="operationTable">
            <el-table :data="tableData" v-loading="tableLoading" border :span-method="objectSpanMethod" row-key="id">
              <el-table-column  prop="number" label="序号" align="center" width="60px"/>
              <el-table-column  prop="consignorName" label="委托单位" align="center" width="130px" show-overflow-tooltip/>
              <el-table-column  prop="type" label="类别" align="center" />
              <el-table-column  prop="batchNumber" label="批次号" align="center" width="110px"/>
              <el-table-column  prop="waybillNo" label="运单号" align="center" width="110px"/>
              <el-table-column  prop="frameNumber" label="底盘号" align="center" width="110px"/>
              <el-table-column  prop="brandName" label="品牌" align="center" />
              <el-table-column  label="起运地" align="center" >
                <template slot-scope="scope">
                  <span>{{ scope.row.startPortName ? scope.row.startPortName : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="交车地" align="center" >
                <template slot-scope="scope">
                  <span>{{ scope.row.deliveryPortName ? scope.row.deliveryPortName : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="物流属性" align="center" width="130px">
                <template slot-scope="scope">
                  <span>{{ scope.row.msCount==1 ? '民生' : '非民生' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="航次结束时间" align="center" width="110px" show-overflow-tooltip>
                <template slot-scope="scope">
                 <span>{{scope.row.endTime | formatTime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        <div class='paginationContainer'>
          <el-pagination
            background
            :page-sizes='[10, 20, 30, 40]'
            layout='total, sizes, prev, pager, next, jumper'
            :total='detailTotal'
            @size-change='detailSizeChange'
            @current-change='detailCurrentChange'
            @prev-click='detailCurrentChange'
            @next-click='detailCurrentChange'
          />
        </div>
        </div>
    </div>
  </el-dialog>
</template>
<script>
import { vehicleDeployInfoDetail} from "@/service/vehiclelog";
import {formatTime} from "@/config/mUtils";

export default {
  data(){
    return{
      detailDialogVisible: false,
      dialogTitle: '',
      tableData: [],
      tableLoading: false,
      detailTotal: 0,
      detailSize: 10,
      detailPage: 1,
      params:{}
    }
  },
  filters: {
    formatTime(val) {
      if (val) {
        return formatTime(val, "yyyy-mm-dd hh:ii:ss")
      } else {
        return ''
      }
    },
  },
  methods:{
    dialogOpen(title,row,deliverStartTime,deliverEndTime,loadingDate,deliveryDate) {
      this.dialogTitle = title
      this.detailDialogVisible = true;
      const data = {
        row:row,
        deliverStartTime:deliverStartTime,
        deliverEndTime:deliverEndTime,
        loadingDate:loadingDate,
        deliveryDate:deliveryDate,
      }
      this.params = data
      this.getVehicleDeployInfoDetail(data)
    },
    async getVehicleDeployInfoDetail(data){
      this.tableLoading = true
      const res = await vehicleDeployInfoDetail({
        consignorName: data.row.consignorName,
        brandName: data.row.brandName,
        type: data.row.type,
        deliverStartTime: data.deliverStartTime,
        deliverEndTime: data.deliverEndTime,
        loadingDate: data.loadingDate,
        deliveryDate: data.deliveryDate,
        page:this.detailPage,
        size:this.detailSize
      });
      if (res.status !== 0) return this.$message.error(res.message);
      this.tableLoading = false
      this.tableData = this.mergeSerialNumbers(res.data.records)
      this.detailTotal = res.data.total
    },
    detailSizeChange(size){
      this.detailSize = size
      this.getVehicleDeployInfoDetail(this.params)
    },
    detailCurrentChange(pages){
      this.detailPage = pages;
      this.getVehicleDeployInfoDetail(this.params)
    },
    mergeSerialNumbers(data){
      let flag = 1
      for(let i = 0; i < data.length; i++) {
        if (data.length - 1 > i) {
          if (data[i].consignorName === data[i + 1].consignorName && data[i].type === data[i + 1].type &&
            data[i].batchNumber === data[i + 1].batchNumber && data[i].waybillNo === data[i + 1].waybillNo &&
            data[i].frameNumber === data[i + 1].frameNumber && data[i].brandName === data[i + 1].brandName) {
            data[i]['number'] = flag
            data[i + 1]['number'] = flag
          } else {
            data[i]['number'] = flag
            flag += 1
          }
        }else {
          if(!data[i]['number']){
            data[i]['number'] = flag
          }
        }
      }
      return data
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
      const data = [
        {
          columnIndex: 0,
          value: 'number',
        },
        {
          columnIndex: 1,
          value: 'consignorName',
        },
        {
          columnIndex: 2,
          value: 'type',
        },
        {
          columnIndex: 3,
          value: 'batchNumber',
        },
        {
          columnIndex: 4,
          value: 'waybillNo',
        },
        {
          columnIndex: 5,
          value: 'frameNumber',
        },
        {
          columnIndex: 6,
          value: 'brandName',
        }
      ];
      for (let index = 0; index < data.length; index++) {
        if (columnIndex === data[index].columnIndex) {
          const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }

      }
    },
    // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
    filterData(arr, value) {
      let spanOneArr = [];
      let concatOne = 0;
      arr.forEach((item, index) => {
        if (index === 0 ) {
          spanOneArr.push(1);
        } else {
            if (item['number'] !== arr[index - 1]['number']) {
              spanOneArr.push(1);
              concatOne = index;
            } else if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
        }
      });
      return spanOneArr;
    },
  }
}
</script>


<style scoped lang="scss">

</style>
